import * as types from '../../constants/app/gameConstants';

export const appListRequest = ({
                                 page, pageLength, searchString, callback, error
}) => ({
  type: types.APP_LIST_REQUEST,
  page,
  pageLength,
  searchString,
  callback,
  error
});

export const setAppList = (list) => ({
  type: types.SET_APP_LIST,
  list,
});

export const appInfoRequest = ({
  appNo,
  callback,
  error,
}) => ({
  type: types.APP_INFO_REQUEST,
  appNo,
  callback,
  error,
});

export const setAppInfo = (info) => ({
  type: types.SET_APP_INFO,
  info,
});

export const appPlayStoreSearchRequest = ({
  packageName,
  callback,
  error,
}) => ({
  type: types.APP_PLAYSTORE_SEARCH_REQUEST,
  packageName,
  callback,
  error,
});

export const appRemoveRequest = (appNo) => ({
  type: types.APP_REMOVE_REQUEST,
  appNo,
});

export const appCreateRequest = ({
  category,
  packageName,
  title,
  developer,
  profileImage,
  appUrl,
  callback,
  error,
}) => ({
  type: types.APP_CREATE_REQUEST,
  category,
  packageName,
  title,
  developer,
  profileImage,
  appUrl,
  callback,
  error,
});

export const appInfoUpdateRequest = ({
  appNo,
  category,
  title,
  developer,
  profileImage,
  distributionChannel,
  appUrl,
  callback,
  error,
}) => ({
  type: types.APP_INFO_UPDATE_REQUEST,
  appNo,
  category,
  title,
  developer,
  profileImage,
  distributionChannel,
  appUrl,
  callback,
  error,
});

export const setPagenation = (page, pageLength, totalCount, searchString) => ({
  type: types.SET_APP_PAGE,
  page,
  pageLength,
  totalCount,
  searchString,
});

export const setRequestStatus = (message, kind) => ({
  type: types.SET_REQUEST_STATUS,
  message,
  kind,
});

export const appResponseMessage = (resultCode) => ({
  type: types.APP_RESPONSE_MESSAGE,
  resultCode,
});
